import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib';
import { fetchCommunities } from '@/lib/api/communities/api';
import { useStanQuery } from '@/queries';

export const useCommunities = () => {
    return useStanQuery(
        {
            queryKey: [QUERY_KEYS.COMMUNITIES],
            queryFn: fetchCommunities,
            staleTime: 1000 * 60 * 5, // 5 minutes
            meta: {
                error: {
                    sentryMessage: '[COMMUNITIES] failed-to-fetch-communities',
                    feature: SENTRY_FEATURES.COMMUNITIES,
                },
            },
        },
        true
    );
};
